import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/layout.vue";
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      component: () => import("../login/login.vue"),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/layout",
      name: "layout",
      component: Layout,
      children: [
        {
          path: "/user",
          component: () => import("../pages/qyMange/baseStaff/baseStaff"),
          meta: {
            title: "用户",
            index: "user"
          }
        },
        {
          path: "/staffAttendance",
          component: () => import("../pages/qyMange/kqjl"),
          meta: {
            title: "临时工考勤记录",
            index: "staffAttendance"
          }
        },
        {
          path: "/codeJob",
          component: () => import("../pages/qyMange/lsg"),
          meta: {
            title: "待入场记录",
            index: "codeJob"
          }
        },
        {
          path: "/dept",
          component: () => import("../pages/qyMange/bm"),
          meta: {
            title: "部门",
            index: "dept"
          }
        },
        {
          path: "/qyda",
          component: () => import("../pages/storeManage/storeAudit/storeAudit.vue"),
          meta: {
            title: "企业",
            index: "qyda"
          }
        },
        {
          path: "/errList",
          component: () => import("../pages/qyMange/errList"),
          meta: {
            title: "北森失败记录",
            index: "errList"
          }
        },
        // errAttendance
        {
          path: "/errAttendance",
          component: () => import("../pages/qyMange/errAttendance"),
          meta: {
            title: "考勤异常记录",
            index: "errAttendance"
          }
        },
        {
          path: "/updateList",
          component: () => import("../pages/qyMange/updateList"),
          meta: {
            title: "临时工修改记录",
            index: "updateList"
          }
        },
        {
          path: "/qydaAdd",
          component: () => import("../pages/storeManage/baseStore/baseStore"),
          meta: {
            title: "企业新增",
            index: "qyda"
          }
        },
        //门店管理 storeManage
        {
          path: "/home",
          component: () => import("../home/home.vue"),
          meta: {
            title: "首页",
            index: "home"
          }
        },
        //门店参数
        {
          path: "/storeParameters",
          component: () =>
            import("../pages/storeManage/storeParameters/storeParameters.vue"),
          meta: {
            title: "门店参数",
            index: "storeParameters"
          }
        },
        //微信公众号
        {
          path: "/tencentAccount",
          component: () =>
            import("../pages/storeManage/tencentAccount/index.vue"),
          meta: {
            title: "微信公众号",
            index: "tencentAccount"
          }
        },
        //职务
        {
          path: "/gradeList",
          component: () => import("../pages/storeManage/gradeList/index.vue"),
          meta: {
            title: "职务",
            index: "gradeList"
          }
        },
        //工种
        {
          path: "/jobList",
          component: () => import("../pages/storeManage/jobList/index.vue"),
          meta: {
            title: "工种",
            index: "jobList"
          }
        },
        // 员工 baseStaff
        {
          path: "/baseStaff",
          component: () =>
            import("../pages/storeManage/baseStaff/baseStaff.vue"),
          meta: {
            title: "已入场记录",
            index: "baseStaff"
          }
        },
        //员工作品
        {
          path: "/staffWorks",
          component: () =>
            import("../pages/storeManage/staffWorks/staffWorks.vue"),
          meta: {
            title: "员工作品",
            index: "staffWorks"
          }
        },
        {
          path: "/feedback",
          component: () =>
            import("../pages/storeManage/feedback/feedback.vue"),
          meta: {
            title: "服务反馈",
            index: "feedback"
          }
        },
        {
          path: "/evaluation",
          component: () =>
            import("../pages/storeManage/evaluation/evaluation.vue"),
          meta: {
            title: "消费评价",
            index: "evaluation"
          }
        },
        //项目类别
        {
          path: "/baseProjectType",
          component: () =>
            import("../pages/storeManage/baseProjectType/baseProjectType"),
          meta: {
            title: "项目类别",
            index: "baseProjectType"
          }
        },
        {
          path: "/repeatPage",
          component: () =>
            import("../pages/storeManage/baseProjectS/baseProject"),
          meta: {
            title: "重复项目",
            index: "repeatPage"
          }
        },
        {
          path: "/smsStatement",
          component: () =>
            import("../pages/storeManage/smsStatement/index.vue"),
          meta: {
            title: "短信对账",
            index: "smsStatement"
          }
        },
        //项目
        {
          path: "/baseProject",
          component: () =>
            import("../pages/storeManage/baseProject/baseProject"),
          meta: {
            title: "项目",
            index: "baseProject"
          }
        },
        //商品
        {
          path: "/goods",
          component: () => import("../pages/storeManage/goods/index"),
          meta: {
            title: "商品",
            index: "goods"
          }
        },
        //充值类别 rechargeType
        {
          path: "/rechargeType",
          component: () =>
            import("../pages/storeManage/rechargeType/rechargeType"),
          meta: {
            title: "充值类别",
            index: "rechargeType"
          }
        },
        //会员清单 memberList
        {
          path: "/memberList",
          component: () => import("../pages/storeManage/memberList/memberList"),
          meta: {
            title: "会员清单",
            index: "memberList"
          }
        },
        //激活会员 activationMember
        {
          path: "/activationMember",
          component: () =>
            import("../pages/storeManage/activationMember/activationMember"),
          meta: {
            title: "激活会员",
            index: "activationMember"
          }
        },
        //会员分派 menmberAllot
        {
          path: "/menmberAllot",
          component: () =>
            import("../pages/storeManage/menmberAllot/menmberAllot"),
          meta: {
            title: "会员分派",
            index: "menmberAllot"
          }
        },

        //员工会员统计表 menmberAllot
        {
          path: "/staffVipSum",
          component: () =>
            import("../pages/storeManage/staffVipSum/staffVipSum.vue"),
          meta: {
            title: "员工会员统计表",
            index: "staffVipSum"
          }
        },
        //门店月度任务 storeTask
        {
          path: "/storeTask",
          component: () =>
            import("../pages/storeManage/storeTask/storeTask.vue"),
          meta: {
            title: "门店月度任务",
            index: "storeTask"
          }
        },
        //会员交易记录 trading
        {
          path: "/trading",
          component: () => import("../pages/storeManage/trading/index.vue"),
          meta: {
            title: "会员交易记录",
            index: "trading"
          }
        },
        {
          path: "/memberReatment",
          component: () => import("../pages/storeManage/memberReatment/index.vue"),
          meta: {
            title: "会员疗程卡包",
            index: "memberReatment"
          }
        },
        //高管业绩 managers
        {
          path: "/managers",
          component: () => import("../pages/storeManage/managers/index.vue"),
          meta: {
            title: "高管业绩",
            index: "managers"
          }
        },
        //管理层业绩 admins
        {
          path: "/admins",
          component: () => import("../pages/storeManage/admins/index.vue"),
          meta: {
            title: "管理层业绩",
            index: "admins"
          }
        },

        // 收银员 easier
        //员工出勤表 attendanceList
        {
          path: "/attendanceList",
          component: () =>
            import("../pages/eashier/attendanceList/attendanceList.vue"),
          meta: {
            title: "员工出勤表",
            index: "attendanceList"
          }
        },
        //预约 subscribe
        {
          path: "/subscribe",
          component: () => import("../pages/eashier/subscribe/subscribe.vue"),
          meta: {
            title: "预约",
            index: "subscribe"
          }
        },
        //预约 Billing
        {
          path: "/payBill",
          component: () => import("../pages/eashier/payBill/payBill.vue"),
          meta: {
            title: "开单",
            index: "payBill"
          }
        },
        //预约叫号 line
        {
          path: "/line",
          component: () => import("../pages/eashier/line/line.vue"),
          meta: {
            title: "预约叫号",
            index: "line"
          }
        },
        //服务单 shareBill
        {
          path: "/services",
          component: () => import("../pages/eashier/service/service.vue"),
          meta: {
            title: "直接收银",
            index: "services",
            keepAlive:true
          }
        },
        {
          path: "/memberAgreement",
          component: () => import("../pages/eashier/memberAgreement/index.vue"),
          meta: {
            title: "会员协议",
            index: "memberAgreement",
          }
        },
        {
          path: "/courseTune",
          component: () => import("../pages/eashier/courseAdjust/raiseReatment.vue"),
          meta: {
            title: "疗程内调",
            index: "courseTune",
          }
        },
        {
          path: "/cardToStore",
          component: () => import("../pages/eashier/cardToStore/index.vue"),
          meta: {
            title: "充值卡转门店",
            index: "cardToStre",
          }
        },
        {
          path: "/shareBill",
          component: () => import("../pages/eashier/proceeds/index.vue"),
          meta: {
            title: "服务单",
            index: "shareBill"
          }
        },
        {
          path: "/proceeds-edit",
          component: () =>
            import("../pages/eashier/proceeds/components/edit.vue"),
          meta: {
            title: "服务单-收银",
            index: "proceeds-edit"
          }
        },
        //充值 shareBill
        {
          path: "/collectionList",
          component: () =>
            import("../pages/eashier/collectionList/collectionList.vue"),
          meta: {
            title: "充值",
            index: "collectionList"
          }
        },
        {
          path: "/smsRecharge",
          component: () =>
            import("../pages/eashier/smsRecharge/index.vue"),
          meta: {
            title: "短信充值",
            index: "smsRecharge"
          }
        },
        //疗程 reatment
        {
          path: "/reatment",
          component: () => import("../pages/eashier/reatment/reatment.vue"),
          meta: {
            title: "疗程",
            index: "reatment"
          }
        },
        // /reatment
        {
          path: "/reatmentInit",
          component: () => import("../pages/eashier/reatment2/reatment.vue"),
          meta: {
            title: "疗程初始化",
            index: "reatmentInit"
          }
        },
        //加价转疗程 raiseReatment
        {
          path: "/raiseReatment",
          component: () =>
            import("../pages/eashier/raiseReatment/raiseReatment.vue"),
          meta: {
            title: "加价转疗程",
            index: "raiseReatment"
          }
        },
        //疗程转充值 coursetorec
        {
          path: "/coursetorec",
          component: () => import("../pages/eashier/coursetorec/index.vue"),
          meta: {
            title: "疗程转充值",
            index: "coursetorec"
          }
        },
        //疗程账户延期 ireatmentdelay
        {
          path: "/ireatmentdelay",
          component: () => import("../pages/eashier/Ireatmentdelay/ireatmentdelay.vue"),
          meta: {
            title: "疗程账户延期",
            index: "ireatmentdelay"
          }
        },
        //充值账户延期 rechargingdelay
        {
          path: "/rechargingdelay",
          component: () => import("../pages/eashier/Rechargingdelay/rechargingdelay.vue"),
          meta: {
            title: "充值账户延期",
            index: "rechargingdelay"
          }
        },
        //充值内调单 within
        {
          path: "/within",
          component: () => import("../pages/eashier/within/within.vue"),
          meta: {
            title: "充值内调单",
            index: "within"
          }
        },
        //注册 sigin
        {
          path: "/signin",
          component: () => import("../pages/eashier/components/signin.vue"),
          meta: {
            title: "注册",
            index: "signin"
          }
        },
        //收款 receipt
        {
          path: "/receipt",
          component: () => import("../pages/eashier/receipt/receipt.vue"),
          meta: {
            title: "收款",
            index: "receipt"
          }
        },
        //消费退 refund
        {
          path: "/refund",
          component: () => import("../pages/eashier/refund/refund.vue"),
          meta: {
            title: "消费退",
            index: "refund"
          }
        },
        //测试 rece
        {
          path: "/rece",
          component: () => import("../pages/eashier/rece.vue"),
          meta: {
            title: "测试",
            index: "rece"
          }
        },
        {
          path: "/refundRecharge",
          component: () =>
            import("../pages/eashier/refundRecharge/refundRecharge.vue"),
          meta: {
            title: "充值退",
            index: "refundRecharge"
          }
        },
        //疗程退 refundCourse
        {
          path: "/refundCourse",
          component: () =>
            import("../pages/eashier/refundCourse/refundCourse.vue"),
          meta: {
            title: "疗程退",
            index: "refundCourse"
          }
        },
        {
          path: "/refundCourse2",
          component: () =>
            import("../pages/eashier/refundCourse copy/refundCourse.vue"),
          meta: {
            title: "疗程退",
            index: "refundCourse2"
          }
        },
        //会员初始化 setImport
        {
          path: "/setImport",
          component: () => import("../pages/eashier/setImport/setImport.vue"),
          meta: {
            title: "会员初始化",
            index: "setImport"
          }
        },
        //会员账户明细 memberAccount
        {
          path: "/memberAccount",
          component: () =>
            import("../pages/eashier/memberAccount/memberAccount.vue"),
          meta: {
            title: "会员账户明细",
            index: "memberAccount"
          }
        },
        //会员账户管理 accountSet
        {
          path: "/accountSet",
          component: () => import("../pages/eashier/accountSet/accountSet.vue"),
          meta: {
            title: "会员账户管理",
            index: "accountSet"
          }
        },
        //还款单 repayment
        {
          path: "/repayment",
          component: () => import("../pages/eashier/repayment/repayment.vue"),
          meta: {
            title: "还款单",
            index: "repayment"
          }
        },
        //取消欠款
        {
          path: "/noarrears",
          component: () => import("../pages/eashier/noArrears/repayment.vue"),
          meta: {
            title: "取消欠款",
            index: "noarrears"
          }
        },
        
        //异常单 errorOrder
        {
          path: "/errorOrder",
          component: () => import("../pages/eashier/errorOrder/index.vue"),
          meta: {
            title: "异常单",
            index: "errorOrder"
          }
        },
        //房间单据退款
        {
          path: "/roomRefund",
          component: () => import("../pages/eashier/roomRefund/index.vue"),
          meta: {
            title: "房间单据退款",
            index: "roomRefund"
          }
        },
        //业绩重算 recountOrder
        {
          path: "/recountOrder",
          component: () => import("../pages/eashier/recount/cIndex.vue"),
          meta: {
            title: "业绩重算",
            index: "recountOrder"
          }
        },
        //员工业绩统计表 staffPerList
        {
          path: "/staffPerList",
          component: () =>
            import("../pages/eashier/staffPerList/staffPerList.vue"),
          meta: {
            title: "员工业绩统计表",
            index: "staffPerList"
          }
        },
        //员工业绩明细 perDetail
        {
          path: "/perDetail",
          component: () => import("../pages/eashier/perDetail/perDetail.vue"),
          meta: {
            title: "员工业绩明细",
            index: "perDetail"
          }
        },
        {
          path: "/test",
          component: () => import("../pages/test.vue"),
          meta: {
            title: "测试",
            index: "test"
          }
        },
        //促销管理

        // 促销报表
        {
          path: "/promotionReport",
          component: () => import("../pages/promotion/promotionReport/index.vue"),
          meta: {
            title: "促销报表",
            index: "promotionReport"
          }
        },

        //  打包价 packing
        {
          path: "/packing",
          component: () => import("../pages/promotion/packing/packing.vue"),
          meta: {
            title: "打包价",
            index: "packing"
          }
        },
        //  买就送 buyandgive
        {
          path: "/buyandgive",
          component: () =>
            import("../pages/promotion//buyandgive/buyandgive.vue"),
          meta: {
            title: "买就送",
            index: "buyandgive"
          }
        },
        //  买就送 sellpacking
        {
          path: "/sellpacking",
          component: () =>
            import("../pages/promotion//sellpacking/sellpacking.vue"),
          meta: {
            title: "促销购买",
            index: "sellpacking"
          }
        },
        {
          path: "/sellpackingTable",
          component: () =>
            import("../pages/promotion//sellpacking/sellpackingTable.vue"),
          meta: {
            title: "促销列表",
            index: "sellpackingTable"
          }
        },
        {
          path: "/recpromotion",
          component: () => import("../pages/promotion/recpromotion/index.vue"),
          meta: {
            title: "充值促销",
            index: "recpromotion"
          }
        },
        {
          path: "/storeSummary",
          component: () =>
            import("../pages/statistics/storeSummary/index.vue"),
          meta: {
            title: "收款总汇",
            index: "storeSummary"
          }
        },
        {
          path: "/storeTotalPerformance",
          component: () =>
            import("../pages/statistics/storeTotalPerformance/index.vue"),
          meta: {
            title: "门店日总业绩",
            index: "storeTotalPerformance"
          }
        },
        {
          path: "/cardCollection",
          component: () =>
            import("../pages/statistics/cardCollection/index.vue"),
          meta: {
            title: "收款明细",
            index: "cardCollection"
          }
        },
        {
          path: "/smsSetup",
          component: () =>
            import("../pages/statistics/smsSetup/index.vue"),
          meta: {
            title: "短信设置",
            index: "smsSetup"
          }
        },
        {
          path: "/storeDaily",
          component: () =>
            import("../pages/statistics/storeDaily/storeDaily.vue"),
          meta: {
            title: "门店日报",
            index: "storeDaily"
          }
        },
        //活跃会员 activeMember
        {
          path: "/activeMember",
          component: () =>
            import("../pages/statistics/activeMember/activeMember.vue"),
          meta: {
            title: "活跃会员",
            index: "activeMember"
          }
        },
        //沉积会员 notActiveMember
        {
          path: "/notActiveMember",
          component: () =>
            import("../pages/statistics/notActiveMember/notActiveMember.vue"),
          meta: {
            title: "沉积会员",
            index: "notActiveMember"
          }
        },
        //新增会员 newMember
        {
          path: "/newMember",
          component: () =>
            import("../pages/statistics/newMember/newMember.vue"),
          meta: {
            title: "新增会员",
            index: "newMember"
          }
        },
        //负卡金  negativeCard
        {
          path: "/negativeCard",
          component: () =>
            import("../pages/statistics/negativeCard/negativeCard.vue"),
          meta: {
            title: "负卡金",
            index: "negativeCard"
          }
        },
        // 负卡金结存 negativeCardBalance
        {
          path: "/negativeCardBalance",
          component: () =>
            import("../pages/statistics/negativeCardBalance"),
          meta: {
            title: "负卡金结存",
            index: "negativeCardBalance"
          }
        },
        //月度营业额 monthlyTaking
        {
          path: "/monthlyTaking",
          component: () =>
            import("../pages/statistics/monthlyTaking/monthlyTaking.vue"),
          meta: {
            title: "月度营业额",
            index: "monthlyTaking"
          }
        },
        //员工提成表 staffBrokerage
        {
          path: "/staffBrokerage",
          component: () =>
            import("../pages/statistics/staffBrokerage/staffBrokerage.vue"),
          meta: {
            title: "员工业绩提成表",
            index: "staffBrokerage"
          }
        },
        // staffBrokerage copy
        {
          path: "/staffBrokerage copy",
          component: () =>
            import("../pages/statistics/staffBrokerage copy/staffBrokerage.vue"),
          meta: {
            title: "员工业绩提成表2",
            index: "staffBrokerage copy"
          }
        },
        {
          path: "/staffBrokerage3",
          component: () =>
            import("../pages/statistics/staffBrokerage3/staffBrokerage.vue"),
          meta: {
            title: "疗程初始化提成表",
            index: "staffBrokerage3"
          }
        },
        //员工排行榜 staffRanking
        {
          path: "/staffRanking",
          component: () =>
            import("../pages/statistics/staffRanking/staffRanking.vue"),
          meta: {
            title: "员工排行榜",
            index: "staffRanking"
          }
        },
        //项目排行榜 projectRanking
        {
          path: "/projectRanking",
          component: () =>
            import("../pages/statistics/projectRanking/projectRanking.vue"),
          meta: {
            title: "项目排行榜",
            index: "projectRanking"
          }
        },
        //会员排行榜  memberRanking
        {
          path: "/memberRanking",
          component: () =>
            import("../pages/statistics/memberRanking/memberRanking.vue"),
          meta: {
            title: "会员排行榜",
            index: "memberRanking"
          }
        },
        //收入分类 incomeClassify
        {
          path: "/incomeClassify",
          component: () =>
            import("../pages/statistics/incomeClassify/incomeClassify.vue"),
          meta: {
            title: "收入分类",
            index: "incomeClassify"
          }
        },
        //员工服务统计 staffService
        {
          path: "/staffService",
          component: () =>
            import("../pages/statistics/staffService/staffService.vue"),
          meta: {
            title: "员工服务统计",
            index: "staffService"
          }
        },
        //员工工资 staffSalary
        {
          path: "/staffSalary",
          component: () =>
            import("../pages/statistics/staffSalary/staffSalary.vue"),
          meta: {
            title: "员工工资",
            index: "staffSalary"
          }
        },
        //门店业绩排行 performance
        {
          path: "/performance",
          component: () =>
            import("../pages/statistics/performance/performance.vue"),
          meta: {
            title: "门店业绩排行",
            index: "performance"
          }
        },
        //门店利润排行 staffSalary
        {
          path: "/storeProfits",
          component: () =>
            import("../pages/statistics/storeProfits/storeProfits.vue"),
          meta: {
            title: "门店利润排行",
            index: "storeProfits"
          }
        },
        //单店经营分析 runAnalyse
        {
          path: "/runAnalyse",
          component: () =>
            import("../pages/statistics/runAnalyse/runAnalyse.vue"),
          meta: {
            title: "单店经营分析",
            index: "runAnalyse"
          }
        },
        //公司经营分析 firmAnalyse
        {
          path: "/firmAnalyse",
          component: () =>
            import("../pages/statistics/firmAnalyse/firmAnalyse.vue"),
          meta: {
            title: "公司经营分析",
            index: "firmAnalyse"
          }
        },
        //关于我们
        {
          path: "/AboutUs",
          component: () => import("../pages/AboutUs/AboutUs"),
          meta: {
            title: "关于我们",
            index: "AboutUs"
          }
        },
        //开通分店
        {
          path: "/openBranch",
          component: () => import("../pages/branch/openBranch/index"),
          meta: {
            title: "开通分店",
            index: "openBranch"
          }
        },
        //分店明细
        {
          path: "/subbranch",
          component: () => import("../pages/branch/subbranch/index"),
          meta: {
            title: "分店明细",
            index: "subbranch"
          }
        },
        {
          path: "/storeCollection",
          component: () => import("../pages/branch/storeCollection/index"),
          meta: {
            title: "分店收款账户",
            index: "storeCollection"
          }
        },
        {
          path: "/receivingPaying",
          component: () => import("../pages/branch/receivingPaying/index"),
          meta: {
            title: "收付款",
            index: "receivingPaying"
          }
        },
        {
          path: "/map",
          component: () => import("../pages/branch/map/index"),
          meta: {
            title: "腾讯地图",
            index: "map"
          }
        },
        {
          path: "/roomCash",
          component: () => import("../pages/eashier/roomCash/index"),
          meta: {
            title: "房间收银",
            index: "roomCash"
          }
        },
        {
          path: "/room",
          component: () => import("../pages/storeManage/room/index"),
          meta: {
            title: "房间",
            index: "room"
          }
        },
        {
          path: "/reconciliation",
          component: () => import("../pages/financialReconciliation/reconciliation/index"),
          meta: {
            title: "财务对账",
            index: "reconciliation"
          }
        },
        // {
        //   path: "/dept",
        //   component: () => import("../pages/storeManage/dept/index"),
        //   meta: {
        //     title: "部门业绩",
        //     index: "dept"
        //   }
        // },
        {
          path: "/giftCards",
          component: () => import("../pages/promotion/giftCards/index"),
          meta: {
            title: "赠卡",
            index: "giftCards"
          }
        },
        {
          path: "/group",
          component: () => import("../pages/promotion/group/index"),
          meta: {
            title: "团购卡",
            index: "group"
          }
        },
        {
          path: "/transfer",
          // component: () => import("../pages/storeManage/transfer/index"), //单独的会员转卡
          component: () => import("../pages/storeManage/transferNew/index"), //批量的会员转卡
          meta: {
            title: "会员转卡",
            index: "transfer"
          }
        },

        {
          path: "/transferstore",
          component: () => import("../pages/storeManage/transferStore/index"), //会员转门店
          meta: {
            title: "疗程转门店",
            index: "transferstore"
          }
        },
        {
          path: "/contribution",
          component: () => import("../pages/statistics/contribution/index"),
          meta: {
            title: "门店单品贡献率",
            index: "contribution"
          }
        },
        {
          path: "/contributions",
          component: () => import("../pages/statistics/contributions/index"),
          meta: {
            title: "公司单品贡献率",
            index: "contributions"
          }
        },
        {
          path: "/memberClass",
          component: () => import("../pages/storeManage/memberClass/index"),
          meta: {
            title: "会员等级",
            index: "memberClass"
          }
        },
        // 优惠券开始
        {
          path: "/couponIssue",
          name: "CouponIssue",
          component: () => import("../pages/discount-coupon/issue/index.vue"),
          meta: {
            title: "建立优惠券",
            index: "couponIssue"
          }
        },
        {
          path: "/couponMane",
          name: "CouponMane",
          component: () =>
            import("../pages/discount-coupon/management/index.vue"),
          meta: {
            title: "管理",
            index: "couponMane"
          }
        },
        {
          path: "/couponRecord",
          component: () => import("../pages/discount-coupon/record/index.vue"),
          meta: {
            title: "领取消费",
            index: "couponRecord"
          }
        },
        // 优惠券结束
        {
          path: "/recommend",
          component: () => import("../pages/statistics/recommend/index.vue"),
          meta: {
            title: "会员拉新排行榜",
            index: "recommend"
          }
        },
        {
          path: "/perCapita",
          component: () => import("../pages/statistics/perCapita/index.vue"),
          meta: {
            title: "人均单价",
            index: "perCapita"
          }
        },
        {
          path: "/activity",
          component: () => import("../pages/statistics/activity/index.vue"),
          meta: {
            title: "活动排行榜",
            index: "activity"
          }
        },
        {
          path: "/achieve",
          component: () => import("../pages/statistics/achieve/index.vue"),
          meta: {
            title: "计划达成",
            index: "achieve"
          }
        },
        {
          path: "/turnover",
          component: () => import("../pages/statistics/turnover/index.vue"),
          meta: {
            title: "商城营收",
            index: "turnover"
          }
        },
        {
          path: "/addMember",
          component: () => import("../pages/statistics/addMember/index.vue"),
          meta: {
            title: "新增会员",
            index: "addMember"
          }
        },
        {
          path: "/alliance",
          component: () => import("../pages/storeManage/alliance/index.vue"),
          meta: {
            title: "加盟商",
            index: "alliance"
          }
        },
        {
          path: "/materials",
          component: () => import("../pages/storeManage/materials/index.vue"),
          meta: {
            title: "物资",
            index: "materials"
          }
        },
        {
          path: "/commodity",
          component: () => import("../pages/statistics/commodity/index.vue"),
          meta: {
            title: "商品营收",
            index: "commodity"
          }
        },
        {
          path: "/separation",
          component: () => import("../pages/statistics/separation/index.vue"),
          meta: {
            title: "离职率",
            index: "separation"
          }
        },
        {
          path: "/expenses",
          component: () => import("../pages/statistics/expenses/index.vue"),
          meta: {
            title: "费用清单",
            index: "expenses"
          }
        },
        {
          path: "/account",
          component: () => import("../pages/statistics/account/index.vue"),
          meta: {
            title: "结算",
            index: "account"
          }
        },
        {
          path: "/efficiency",
          component: () => import("../pages/statistics/efficiency/index.vue"),
          meta: {
            title: "活动效率比",
            index: "efficiency"
          }
        },
        {
          path: "/activityNew",
          component: () => import("../pages/statistics/activityNew/index.vue"),
          meta: {
            title: "活动新会员",
            index: "activityNew"
          }
        },
        {
          path: "/seniority",
          component: () => import("../pages/statistics/seniority/index.vue"),
          meta: {
            title: "服务年限",
            index: "seniority"
          }
        },
        {
          path: "/memberTime",
          component: () => import("../pages/statistics/memberTime/index.vue"),
          meta: {
            title: "会员时长",
            index: "memberTime"
          }
        },
        {
          path: "/income",
          component: () => import("../pages/statistics/income/index.vue"),
          meta: {
            title: "创收",
            index: "income"
          }
        },
        {
          path: "/collaboration",
          component: () =>
            import("../pages/statistics/collaboration/index.vue"),
          meta: {
            title: "合作费用",
            index: "collaboration"
          }
        },
        {
          path: "/verification",
          component: () => import("../pages/statistics/verification/index.vue"),
          meta: {
            title: "合作费用支付",
            index: "verification"
          }
        },
        {
          path: "/handpick",
          component: () => import("../pages/promotion/handpick/index.vue"),
          meta: {
            title: "随心配",
            index: "handpick"
          }
        },
        {
          path: "/role",
          component: () => import("../pages/storeManage/role/index.vue"),
          meta: {
            title: "角色",
            index: "role"
          }
        },
        // 报表统计开始----
        {
          path: "/courseStatistics",
          component: () =>
            import("../pages/statistics/courseStatistics/index.vue"),
          meta: {
            title: "疗程统计表",
            index: "courseStatistics"
          }
        },
        {
          path: "/scalpCourse",
          component: () =>
            import("../pages/statistics/scalpCourse/index.vue"),
          meta: {
            title: "头皮疗程明细",
            index: "scalpCourse"
          }
        },
        {
          path: "/projectCourse",
          component: () =>
            import("../pages/statistics/projectCourse/index.vue"),
          meta: {
            title: "美容大项目疗程表",
            index: "projectCourse"
          }
        },
        {
          path: "/manageWages",
          component: () =>
            import("../pages/statistics/manageWages/index.vue"),
          meta: {
            title: "管理层工资表",
            index: "manageWages"
          }
        },
        {
          path: "/IndividualPerformance",
          component: () =>
            import("../pages/statistics/IndividualPerformance/index.vue"),
          meta: {
            title: "个人业绩",
            index: "IndividualPerformance"
          }
        },
        {
          path: "/scalpProject",
          component: () =>
            import("../pages/statistics/scalpProject/index.vue"),
          meta: {
            title: "头皮项目登记表",
            index: "scalpProject"
          }
        },
        {
          path: "/monCommission",
          component: () =>
            import("../pages/statistics/monCommission/index.vue"),
          meta: {
            title: "每日业绩明细表",
            index: "monCommission"
          }
        },
        {
          path: "/cashReward",
          component: () =>
            import("../pages/statistics/cashReward/index.vue"),
          meta: {
            title: "门店现金奖励表",
            index: "cashReward"
          }
        },
        {
          path: "/monthlyRegistrationDetails",
          component: () =>
            import("../pages/statistics/cashReward/index.vue"),
          meta: {
            title: "奖励登记明细",
            index: "monthlyRegistrationDetails"
          }
        },
        {
          path: "/projectPinCard",
          component: () =>
            import("../pages/statistics/projectPinCard/index.vue"),
          meta: {
            title: "大项目销卡登记表",
            index: "projectPinCard"
          }
        },
        {
          path: "/storeConsultant",
          component: () =>
            import("../pages/statistics/storeConsultant/index.vue"),
          meta: {
            title: "管理层每日业绩表",
            index: "storeConsultant"
          }
        },
        {
          path: "/storeTurnover",
          component: () =>
            import("../pages/statistics/storeTurnover/index.vue"),
          meta: {
            title: "门店营业额登记表",
            index: "storeTurnover"
          }
        },
        {
          path: "/productStatistics",
          component: () =>
            import("../pages/statistics/productStatistics/index.vue"),
          meta: {
            title: "产品统计",
            index: "productStatistics"
          }
        },
        // 报表统计结束----
        {
          path: "/parthnersArchives",
          component: () =>
            import("../pages/partners/parthnersArchives/index.vue"),
          meta: {
            title: "合作商",
            index: "parthnersArchives"
          }
        },
        {
          path: "/partnersProject",
          component: () =>
            import("../pages/partners/partnersProject/index.vue"),
          meta: {
            title: "合作项目",
            index: "partnersProject"
          }
        },
        {
          path: "/partnersList",
          component: () =>
            import("../pages/partners/partnersList/index.vue"),
          meta: {
            title: "合作商报表",
            index: "partnersList"
          }
        },
        {
          path: "/reconciliationDetails",
          component: () =>
            import("../pages/partners/reconciliationDetails/index.vue"),
          meta: {
            title: "对账明细表",
            index: "reconciliationDetails"
          }
        },
        {
          path: "/permissions",
          component: () => import("../pages/statistics/Permissions"),
          meta: {
            index: "permissions",
            title: "权限"
          }
        },
      ]
    }
  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js